import React from 'react'

import { Color } from 'const'

const ChevronIcon = ({ className, fill = Color.FONT.NORMAL }) => (
  <svg className={className} width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.72168 7.36578L1.34415 12.6992L0 11.3661L4.70546 6.69922L0 2.03234L1.34415 0.699219L6.72168 6.03266C6.89989 6.20946 7 6.44922 7 6.69922C7 6.94922 6.89989 7.18898 6.72168 7.36578Z"
      fill={fill}
    />
  </svg>
)

export default ChevronIcon
